const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
// Domaine public de marque (liens partagés : parrainage, portails, sites)
export const PUBLIC_SITE = (process.env.REACT_APP_PUBLIC_SITE_URL || "https://off-markette.com").replace(/\/$/, "");

export const fmtPrice = (n) =>
  new Intl.NumberFormat("fr-FR").format(n || 0) + " €";

export async function fetchListings(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== "" && v !== null && v !== undefined) qs.append(k, v);
  });
  const res = await fetch(`${API}/listings?${qs.toString()}`);
  if (!res.ok) return [];
  return res.json();
}

export async function fetchListing(slug) {
  const res = await fetch(`${API}/listings/${slug}`, { credentials: "include" });
  if (!res.ok) return null;
  return res.json();
}

export async function fetchFacets() {
  const res = await fetch(`${API}/listings/facets`);
  if (!res.ok) return { cities: [], advisors: [], agencies: [] };
  return res.json();
}

export async function fetchMembers(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v) qs.append(k, v); });
  const res = await fetch(`${API}/members?${qs.toString()}`);
  if (!res.ok) return [];
  return res.json();
}

export async function fetchMember(slug) {
  const res = await fetch(`${API}/members/${slug}`);
  if (!res.ok) return null;
  return res.json();
}

export async function fetchConseillerDuMois() {
  try {
    const res = await fetch(`${API}/conseiller-du-mois`);
    if (!res.ok) return null;
    return res.json();
  } catch (_) { return null; }
}

export async function fetchPartnerSite(slug) {
  const res = await fetch(`${API}/members/${slug}/site`);
  if (!res.ok) return null;
  return res.json();
}

export async function fetchSiteNetwork(slug) {
  const res = await fetch(`${API}/members/${slug}/network`);
  if (!res.ok) return { members: [] };
  return res.json();
}

export async function submitSiteContact(slug, data) {
  const res = await fetch(`${API}/members/${slug}/contact`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data),
  });
  if (!res.ok) { let d = "Envoi impossible"; try { d = (await res.json()).detail || d; } catch (_) {} throw new Error(typeof d === "string" ? d : "Envoi impossible"); }
  return res.json();
}

export async function submitListingInquiry(slug, data) {
  const res = await fetch(`${API}/members/${slug}/listing-inquiry`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data),
  });
  if (!res.ok) { let d = "Envoi impossible"; try { d = (await res.json()).detail || d; } catch (_) {} throw new Error(typeof d === "string" ? d : "Envoi impossible"); }
  return res.json();
}

export async function siteAIChat(slug, messages, sessionId) {
  const res = await fetch(`${API}/members/${slug}/ai-chat`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ messages, session_id: sessionId }),
  });
  if (!res.ok) { let d = "Assistant indisponible"; try { d = (await res.json()).detail || d; } catch (_) {} throw new Error(typeof d === "string" ? d : "Assistant indisponible"); }
  return res.json();
}

export async function siteAILead(slug, data) {
  const res = await fetch(`${API}/members/${slug}/ai-lead`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data),
  });
  if (!res.ok) { let d = "Envoi impossible"; try { d = (await res.json()).detail || d; } catch (_) {} throw new Error(typeof d === "string" ? d : "Envoi impossible"); }
  return res.json();
}

export async function siteAIBook(slug, data) {
  const res = await fetch(`${API}/members/${slug}/ai-book`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data),
  });
  if (!res.ok) { let d = "Réservation impossible"; try { d = (await res.json()).detail || d; } catch (_) {} throw new Error(typeof d === "string" ? d : "Réservation impossible"); }
  return res.json();
}

export async function reformulateMessage(text) {
  const res = await fetch(`${API}/ai/reformulate`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ text }),
  });
  if (!res.ok) { let d = "Amélioration impossible"; try { d = (await res.json()).detail || d; } catch (_) {} throw new Error(typeof d === "string" ? d : "Amélioration impossible"); }
  return res.json();
}

// Bannières de couverture par défaut des pages du site partenaire (fallback)
export const SITE_DEFAULT_COVERS = {
  annonces: "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/49bb0ae9bc158fcafcda3cdc192be8d31af1a195266aab1ce8ed8c84fe370a41.png",
  presentation: "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/a3f8304bb9b9b6ad4f4c0504b39ada6f6f367f1799492135101ba7ed2980f91f.png",
  expertises: "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/e5d66e2a543781078103fb72434ca91179ac87d7cd4c68c26fe78c482a7af6e6.png",
  partenaires: "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/6e7507f93c88d023c3ed87de7f42c126b20f96e6618c3b5865df74491e2606a2.png",
  contact: "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/b5c7741da684e17830982b5b5ea277a032a9d2af10894a1b987bc2e6bb00b57a.png",
  reseau: "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/600d79c4d3428c56d4329290fb0125dc674d59702ee18b02645890ab1f4027ae.png",
  monreseau: "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/600d79c4d3428c56d4329290fb0125dc674d59702ee18b02645890ab1f4027ae.png",
  news: "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/e5d66e2a543781078103fb72434ca91179ac87d7cd4c68c26fe78c482a7af6e6.png",
};


export async function submitProperty(data) {
  const res = await fetch(`${API}/submissions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    let d = "Envoi impossible"; try { d = (await res.json()).detail || d; } catch (_) {}
    throw new Error(typeof d === "string" ? d : "Envoi impossible");
  }
  return res.json();
}

export async function submitPropertyFromUrl(data) {
  const res = await fetch(`${API}/submissions/from-url`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    let d = "Envoi impossible"; try { d = (await res.json()).detail || d; } catch (_) {}
    throw new Error(typeof d === "string" ? d : "Envoi impossible");
  }
  return res.json();
}

export async function uploadSubmissionFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API}/submissions/upload`, { method: "POST", body: fd });
  if (!res.ok) {
    let d = "Upload impossible"; try { d = (await res.json()).detail || d; } catch (_) {}
    throw new Error(typeof d === "string" ? d : "Upload impossible");
  }
  return res.json(); // { url, path, name }
}

export const LOGO_URL = "/off-markette-logo.png?v=4";
export const GOLD = "#C19A6B";

// Portraits Vincent Marette (photos fournies)
const _AST = "https://customer-assets.emergentagent.com/job_appart-jardin/artifacts/";
export const VINCENT_STUDIO = _AST + "it273fo1_WhatsApp%20Image%202026-07-08%20at%2012.48.15%20%281%29.jpeg";
export const VINCENT_STUDIO_ALT = _AST + "ugtlh6qt_WhatsApp%20Image%202026-07-08%20at%2012.48.45%20%281%29.jpeg";
export const VINCENT_CASUAL = _AST + "sm8h96mw_WhatsApp%20Image%202026-07-08%20at%2012.50.26.jpeg";
export const VINCENT_CAR = _AST + "m0jq5786_WhatsApp%20Image%202026-07-08%20at%2012.50.38.jpeg";

// Visuels page « Proposez votre bien » (générés)
export const PROPOSER_HERO = "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/690f9fbb008fc2c26a987a480c7d8f74d56aabee50315c9e7743307e77fc9fe9.png";
export const PROPOSER_ONLINE_IMG = "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/8ea293df22ac6a1c0fbf0fae2de34d220258fad25d9aff7df94741a0373597af.png";
export const PROPOSER_OFFLINE_IMG = "https://static.prod-images.emergentagent.com/jobs/8e57cf35-f4fb-40ce-b502-ff37f5224c96/images/e81f51793668ab0610a6205a421961cf3e95caa00927f3dde6e9aeeceb172a15.png";
